/*
*
* File JS componente Archive Filters
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './archive-filters.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const archiveFilters = () => {

    let archiveFilterBlock = document.querySelector('.pg-archive-press .archive-filters');
    let btnFilters = document.querySelector('.archive-filters__submit');
    let selectFilters = document.querySelector('.archive-filters__select');

    if (!archiveFilterBlock) return;
    
    btnFilters.addEventListener('click', () => 
    {
        let url = selectFilters.value;
        let formAction = archiveFilterBlock.querySelector('form').action;
        
        if (url == '-1')
        {
            window.location = formAction;
            return;
        }

        if (url) 
        { // require a URL
            window.location = formAction  + url; // redirect
        }
        return false;
    });
}

export default archiveFilters;

//--------------------------------------------------------------------//